import { EnvironmentBanner } from "@homebound/beam";
import { useEnvironmentBannerProps } from "src/routing/components/useEnvironmentBannerProps";

export function EnvBanner() {
  return <EnvironmentBanner {...useEnvironmentBannerProps()} />;
}
